import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { thousandsSeparator } from 'common/utils';
import css from './Details.scss';
import Graph from '../Graph';

const text = {
	nationalAvgTitle: 'ממוצע ארצי',
	agvGrade: 'ציון ממוצע',
	totalStudents: 'סה"כ נבחנים',
	place: 'מיקום ארצי',
};

const getValue = value => value || '—';

const Details = props => {
	const [year, setYear] = React.useState(_.last(props.years));
	const national = _.find(props.nationalAvg, o => o.year === year) || {};

	return (
		<div className={css.details}>
			<div className={css.buttons}>
				{_.map(props.years, y => (
					<Details.Button
						key={`details-btn-${y}`}
						year={y}
						isActive={y === year}
						onClick={selectedYear => {
							setYear(selectedYear);
						}}
					/>
				))}
			</div>
			<div className={css.detailsItems}>
				<Details.Item
					title={text.nationalAvgTitle}
					grade={getValue(national.avarageScore)}
					students={getValue(national.studentNum)}
					color={Graph.colors.national}
				/>
				{_.map(props.cities, (city, index) => {
					const cityObj = _.find(props.citiesAvg, o => o.city === city && o.year === year);
					if (!cityObj) {
						return null;
					}
					return (
						<Details.Item
							key={city}
							title={city}
							grade={getValue(cityObj.avarageScore)}
							students={getValue(cityObj.studentNum)}
							place={cityObj.rank || `${_.random(1, 255)}/255`}
							color={Graph.colors.cities[index]}
						/>
					);
				})}
			</div>
		</div>
	);
};

const Item = ({ title, grade, students, place, color }) => {
	return (
		<div className={css.detailsItem}>
			{title && (
				<h2 style={{ color }} className={css.detailsTitle}>
					{title}
				</h2>
			)}
			{grade && (
				<p>
					{`${text.agvGrade}:`}
					<span>{grade}</span>
				</p>
			)}
			{students && (
				<p>
					{`${text.totalStudents}: `}
					<span>{thousandsSeparator(students)}</span>
				</p>
			)}
			{place && <p>{`${text.place}: ${place}`}</p>}
		</div>
	);
};

const Button = ({ year, onClick, isActive }) => {
	return (
		<button className={cn(css.btn, { [css.active]: isActive })} type="button" onClick={() => onClick(year)}>
			{year}
		</button>
	);
};

Details.Item = Item;

Details.Button = Button;

Details.propTypes = {
	years: PropTypes.arrayOf(PropTypes.string).isRequired,
	cities: PropTypes.arrayOf(PropTypes.string).isRequired,
	nationalAvg: PropTypes.shape({}).isRequired,
	citiesAvg: PropTypes.shape({}).isRequired,
};

Item.propTypes = {
	title: PropTypes.string.isRequired,
	grade: PropTypes.string.isRequired,
	students: PropTypes.string.isRequired,
	place: PropTypes.string,
	color: PropTypes.string.isRequired,
};

Item.defaultProps = {
	place: '',
};

Button.propTypes = {
	year: PropTypes.string.isRequired,
	onClick: PropTypes.func.isRequired,
	isActive: PropTypes.bool.isRequired,
};

export default Details;
